import { apiClient } from "../apiClient";
import { apiConnector } from "../apiConnector";
import {jwtDecode} from "jwt-decode";
import toast from "react-hot-toast";
import { setUserData,setToken } from "../../slices/employee/userAuthSlice";
import {setUserAttendanceData} from '../../slices/employee/userAttendance'
import {setUserLeaveData} from '../../slices/employee/userLeave'
import {setUserHolidaysData} from '../../slices/employee/userHolidays'
import { setUser } from "../../slices/profileSlice";
import { ACCOUNT_TYPE } from "../../utils/Account_Type";

export function UserDetails(token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector("GET", apiClient.USER_DETAILS_URL, null, {
        Authorization: `Bearer ${token}`
      })
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      const employeeDetails = res?.data?.data
      const profileData = { ...employeeDetails, role: ACCOUNT_TYPE.USER }

      dispatch(setUserData(employeeDetails))
      dispatch(setUser(profileData))
      localStorage.setItem("user", JSON.stringify(profileData))   // NEW — hydrates state.profile.user synchronously on refresh

      toast.success(res?.data?.message)
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
    }
  }
}
export function UserLogin(payload, navigate) {
  return async (dispatch) => {
    try {
      const res = await apiConnector('POST', apiClient.LOGIN_URL, payload)
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      toast.success(res?.data?.message)
      dispatch(setToken(res?.data?.data))
      localStorage.setItem('token', res?.data?.data)
      dispatch(UserDetails(res?.data?.data))
      if (navigate) navigate('/dashboard')
      return res?.data
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
      return error?.response?.data
    }
  }
}
export function UserChangePassword(payload,token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector('POST', apiClient.USER_CHANGE_PASSWORD, payload,{
        Authorization:`Bearer ${token}`
      })
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      toast.success(res?.data?.message)
      return res
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
      return error?.response
    }
  }
}
export function isTokenExpired(token){
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch (err) {
    return true;
  }
};

/* =================== User Attendance Bussines Logic =================== */
export function UserAttendance(from,to,token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector("GET", apiClient.USER_ATTENDANCE_URL + `/${from}/${to}`, null, {
        Authorization: `Bearer ${token}`
      })
      console.log("Attendance Response:", res)
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      dispatch(setUserAttendanceData(res?.data?.data))
      toast.success(res?.data?.message)
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
    }
  }
}
export function UserAddRemarkAttendance(AttendanceId,payload,token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector("POST", apiClient.USER_ADD_REMARK_ATTENDANCE_URL + `/${AttendanceId}`, payload, {
        Authorization: `Bearer ${token}`
      })
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      dispatch(UserAttendance(token))
      toast.success(res?.data?.message)
      return res
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
      return error?.response
    }
  }
}

/* =================== User Leave Bussines Logic =================== */
export function UserLeave(token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector('GET', apiClient.USER_LEAVES_URL, null,{
        Authorization:`Bearer ${token}`
      })
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      toast.success(res?.data?.message)
      dispatch(setUserLeaveData(res?.data?.data))
      return res
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
      return error?.response
    }
  }
}
export function UserApplyLeave(payload,token) {
    console.log("Payload Leave:",payload)
  return async (dispatch) => {
    try {
      const res = await apiConnector('POST', apiClient.USER_APPLY_LEAVE_URL, payload,{
        Authorization:`Bearer ${token}`
      })
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      toast.success(res?.data?.message)
      dispatch(UserLeave(token))
      return res
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
      return error?.response
    }
  }
}

/* =================== User Holidays Bussines Logic =================== */
export function UserHolidays(token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector('GET', apiClient.USER_HOLIDAYS_URL, null,{
        Authorization:`Bearer ${token}`
      })
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      console.log("Holidays:",res?.data?.data)
      toast.success(res?.data?.message)
      dispatch(setUserHolidaysData(res?.data?.data))
      return res
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
      return error?.response
    }
  }
}
export function UserLogout(navigate) {
  return (dispatch) => {
    dispatch(setToken(null));
    dispatch(setUserData(null));
    dispatch(setUser(null));
    localStorage.removeItem('token');
    localStorage.removeItem('user');   // NEW
    toast.success("Logged Out");
    if (navigate) navigate('/login', { replace: true });
  }
}